import "core-js/modules/es.array.concat.js";
import { postReq, putReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/borrower-work-place");
export var addBorrowerWorkingPlace = function addBorrowerWorkingPlace(idNumber, body) {
  return postReq("".concat(BASE_URL, "/").concat(idNumber), body);
};
export var editBorrowerWorkingPlace = function editBorrowerWorkingPlace(id, body) {
  return putReq("".concat(BASE_URL, "/").concat(id), body);
};